import { useEffect, useState } from "react";
import api from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { BookMarked } from "lucide-react";

function formatHistoryDate(value) {
  if (!value) return "";
  const v = String(value).trim();
  // Pure year (e.g. "2024")
  if (/^\d{4}$/.test(v)) return v;
  // YYYY-MM-DD or full ISO
  const d = new Date(v);
  if (!isNaN(d.getTime())) {
    return d.toLocaleDateString("pl-PL", { day: "2-digit", month: "long", year: "numeric" });
  }
  return v;
}

export default function History() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/history").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-5 py-12" data-testid="history-page">
      <SectionHeader title="Historia" />
      <p className="text-center mt-4 mb-12" style={{ color: "var(--sr-cream-soft)" }}>
        Kronika klubu Scythe Riders — od pierwszej iskry, krok po kroku.
      </p>

      {items.length === 0 ? (
        <p className="text-center" style={{ color: "var(--sr-muted)" }}>
          Brak wpisów. Admin dodaje wydarzenia z Panelu Admina.
        </p>
      ) : (
        <div className="relative">
          {/* Timeline line */}
          <div
            className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px"
            style={{ background: "linear-gradient(180deg, transparent, var(--sr-fire), transparent)" }}
          />

          <div className="space-y-8">
            {items.map((h, i) => (
              <article
                key={h.id}
                className={`md:flex md:items-center md:gap-8 ${i % 2 === 0 ? "" : "md:flex-row-reverse"} fade-up`}
                style={{ animationDelay: `${i * 80}ms` }}
                data-testid={`history-${h.id}`}
              >
                <div className="md:w-1/2">
                  <div className="sr-card p-6">
                    <div className="flex items-center gap-2 mb-2">
                      <BookMarked size={16} className="text-[var(--sr-fire)]" />
                      <span className="font-nav text-xs uppercase tracking-widest" style={{ color: "var(--sr-fire-2)" }}>
                        {formatHistoryDate(h.date)}
                      </span>
                    </div>
                    <h3 className="font-display text-xl md:text-2xl text-[var(--sr-cream)]">{h.title}</h3>
                    <p className="mt-3 whitespace-pre-wrap" style={{ color: "var(--sr-cream-soft)" }}>{h.description}</p>
                  </div>
                </div>

                {/* Timeline dot (desktop) */}
                <div className="hidden md:flex md:w-12 items-center justify-center">
                  <span
                    className="block w-4 h-4 rounded-full"
                    style={{
                      background: "var(--sr-fire)",
                      boxShadow: "0 0 0 4px rgba(12,10,9,1), 0 0 20px var(--sr-fire)",
                    }}
                  />
                </div>

                <div className="hidden md:block md:w-1/2" />
              </article>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
